export default class Close {
  constructor(handleClick) {
    this.closeButton = document.createElement('button');
    this.closeButton.classList.add('ac-map__close');
    this.closeButton.innerText = '';
    this.closeButton.addEventListener('click', handleClick);
  }

  getElement() {
    return this.closeButton;
  }
}

